import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { saveGuideStepOrder as saveGuideStepOrderFromMonolith } from '~/monolith-api/guides/saveGuideStepOrder';

const saveGuideStepOrderSchema = z.object({
   guideid: z.number(),
   revisionid: z.number(),
   stepids: z.array(z.number()),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { guideid, revisionid, stepids } = saveGuideStepOrderSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await saveGuideStepOrderFromMonolith(guideid, revisionid, stepids, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const saveGuideStepOrder = async (
   guideid: number,
   revisionid: number,
   stepids: number[]
): Promise<typeof saveGuideStepOrderFromMonolith> => {
   return bff()
      .post('/guides/saveGuideStepOrder', {
         guideid,
         revisionid,
         stepids,
      })
      .then(response => response.data);
};
